import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './sections/HeroSection';
// Lazy load below-fold sections to reduce initial JS bundle
const ProblemSection = lazy(() => import('./sections/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('./sections/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const TomosSection = lazy(() => import('./sections/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonusPricingSection = lazy(() => import('./sections/BonusPricingSection').then(m => ({
  default: m.BonusPricingSection
})));
const TestimonialsFAQSection = lazy(() => import('./sections/TestimonialsFAQSection').then(m => ({
  default: m.TestimonialsFAQSection
})));
const SocialProofPopup = lazy(() => import('./SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function SalesPage() {
  useEffect(() => {
    // Inject preconnect hints for critical origins
    const preconnects = [{
      href: 'https://cdn.magicpatterns.com',
      crossorigin: false
    }];
    const linkElements: HTMLLinkElement[] = [];
    preconnects.forEach(({
      href,
      crossorigin
    }) => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      if (crossorigin) link.crossOrigin = '';
      document.head.appendChild(link);
      linkElements.push(link);
    });
    // Defer Meta Pixel loading until after page is interactive
    const pixelId = '1688179945683486';
    let script: HTMLScriptElement | null = null;
    let noscript: HTMLElement | null = null;
    const loadPixel = () => {
      script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${pixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    };
    // Use requestIdleCallback if available, otherwise setTimeout
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 2000);
    }
    return () => {
      linkElements.forEach(el => {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      if (script && script.parentNode) script.parentNode.removeChild(script);
      if (noscript && noscript.parentNode) noscript.parentNode.removeChild(noscript);
    };
  }, []);
  return <main className="min-h-screen bg-[#FAF7F2] font-sans text-[#1B4332] selection:bg-[#D4A853] selection:text-[#1B4332]" data-id="element-1">
      <HeroSection data-id="element-2" />
      <Suspense fallback={<div className="min-h-[200px]" data-id="element-4" />} data-id="element-3">
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <TomosSection data-id="element-7" />
        <BonusPricingSection data-id="element-8" />
        <TestimonialsFAQSection data-id="element-9" />
        <SocialProofPopup data-id="element-10" />
      </Suspense>
    </main>;
}